// features/licenses/api.ts
import api from "src/services/api";
import type { LicenseApi } from "./types";

export async function fetchLicenses(): Promise<LicenseApi[]> {
  const res: any = await api.get("/licenses/with-product?isMonthly=1");
  return res?.data?.licenseList ?? res?.licenseList ?? res ?? [];
}
